module.exports = __webpack_public_path__ + "kn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kn.svg
// module id = 642
// module chunks = 0